export const formatNumber = (number) => {
  const decimals = number < 1000 ? 1 : 0;
  if (number === null || number === undefined) return '-';
  return new Intl.NumberFormat('da-DK', {
    maximumFractionDigits: decimals,
  }).format(number);
};

export const formatHour = (decimalHour) => {
  const hour = Math.floor(decimalHour);
  const minutesDecimal = decimalHour - hour;
  const minutes = Math.round(minutesDecimal * 60); // converts 0.0833 to 5, 0.9167 to 55 etc.
  const minutesPadded = minutes.toString().padStart(2, '0');
  return `${hour.toString().padStart(2, '0')}:${minutesPadded}`;
};

export const hexToRgb = (hex) => {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
        result[3],
        16,
      )}`
    : null;
};

export function formatTimestamp(isoString) {
  if (!isoString) return '';

  const date = new Date(isoString);

  // Options for formatting
  const options = {
    day: '2-digit',
    month: 'short', // "Jun"
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };

  return date.toLocaleString(undefined, options);
}
